<template>
    <div>
        <app-bar :title="t('premium_main_goals_title')"></app-bar>

        <template v-if="touchedGoal.exists()">
            <v-app-bar
                color="transparent"
                height="84"
                elevation="0"
                class="mb-n6 px-6"
            >
                <v-toolbar-title>{{ touchedGoal.title }}</v-toolbar-title>
                <v-btn
                    @click="unset()"
                    plain
                    icon
                    absolute
                    right
                    class="mr-n8"
                ><v-icon>mdi-close</v-icon></v-btn>
            </v-app-bar>

            <div class="px-10 pb-6 overflow-hidden">
                <user-main-goal-view :goal="touchedGoal"></user-main-goal-view>
            </div>
        </template>

        <v-layout>
            <template v-if="! touchedGoal.exists()">
                <user-main-goal-collection
                    @touched="touch"
                ></user-main-goal-collection>
            </template>
        </v-layout>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref } from '@vue/composition-api'
import { useI18n } from 'vue-i18n-composable'
import { UserMainGoal } from '@/core/models/user-main-goal'
import UserMainGoalCollection from '@/components/main-goals/UserMainGoalCollection.vue'
import UserMainGoalView from '@/components/main-goals/UserMainGoalView.vue'

export default defineComponent({
    components: {
        UserMainGoalCollection,
        UserMainGoalView,
    },

    setup() {
        const touchedGoal = ref(new UserMainGoal(<any>{}))

        const touch = (goal: UserMainGoal) => {
            Object.assign(touchedGoal.value, goal)
        }

        const unset = () => {
            touchedGoal.value.unset()
        }

        return {
            touchedGoal: <UserMainGoal>touchedGoal.value,
            touch,
            unset,
            ...useI18n(),
        }
    },
})
</script>
